import React from "react"
import styled from "styled-components"

const SaleDetails = styled.div`
display: flex;
flex-direction:row;
justify-content: space-between;
margin-bottom: 10px;
font-family: roboto;
border-top-right-radius: 30px;
border-bottom-right-radius: 30px;
padding-top: 20px;
padding-bottom: 20px;

@media(max-width: 600px){
    display: flex;
    padding-top: 10px;
    padding-bottom: 10px;
    flex-direction: column;
    justify-content: center;
    alig-self: center !important;
}`
const Tag = styled.div`
padding-left: 10px;
display: flex;
`
const TagTitle = styled(Tag)``

const TagValue = styled(Tag)`
font-weight: bold;
`

export default props => <SaleDetails>
    <div>
        <Tag>
            <TagTitle>Sub Total</TagTitle>
            <TagValue>{props.subTotal}</TagValue>
        </Tag>
    </div>
    <div>
        <Tag>
            <TagTitle>Desconto</TagTitle>
            <TagValue>{props.discountValue}</TagValue>
        </Tag>
    </div>
    <div>
        <Tag>
            <TagTitle>Total</TagTitle>
            <TagValue>{props.totalAmount}</TagValue>
        </Tag>
    </div>
</SaleDetails>


// WEBPACK FOOTER //
// ./src/views/AppViews/POS/components/SaleResume/index.jsx